<template>
  <el-dialog
    :title="editIntegralInfo.detailType === '1001' ? $t('editIntegral.givePoints') : $t('editIntegral.deductPoints')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form label-width="120px">
      <el-form-item :label="$t('editIntegral.pointsAccount')">
        <el-input v-model="editIntegralInfo.integralName" disabled />
      </el-form-item>
      <el-form-item :label="$t('editIntegral.remainingPoints')">
        <el-input v-model="editIntegralInfo.amount" disabled />
      </el-form-item>
      <el-form-item :label="editIntegralInfo.detailType === '1001' ? $t('editIntegral.giveAmount') : $t('editIntegral.deductAmount')">
        <el-input
          v-model="editIntegralInfo.value"
          type="number"
        />
      </el-form-item>
      <el-form-item :label="$t('editIntegral.remark')">
        <el-input
          v-model="editIntegralInfo.remark"
          type="textarea"
          :placeholder="$t('editIntegral.remarkPlaceholder')"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editIntegral">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { changeIntegralAmount } from '@/api/admin/integralApi'

export default {
  name: 'EditIntegral',
  data() {
    return {
      dialogVisible: false,
      editIntegralInfo: {
        detailType: '',
        integralName: '',
        integralId: '',
        amount: '',
        value: '',
        remark: ''
      }
    }
  },
  methods: {
    open(params) {
      this.editIntegralInfo = { ...params }
      this.dialogVisible = true
    },
    handleClose() {
      this.editIntegralInfo = {
        detailType: '',
        integralName: '',
        integralId: '',
        amount: '',
        value: '',
        remark: ''
      }
    },
    async editIntegral() {
      if (!this.validate()) {
        return
      }

      try {
        await changeIntegralAmount(this.editIntegralInfo)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('editIntegral.operateSuccess'))
      } catch (error) {
        console.error(error)
      }
    },
    validate() {
      if (!this.editIntegralInfo.value) {
        this.$message.warning(this.$t('editIntegral.quantityRequired'))
        return false
      }
      return true
    }
  }
}
</script>